import { Box, Divider, Grid, Skeleton } from "@mui/material";

import { PageContainer } from "@/src/components/atoms";
import { BreadcrumbPanel } from "@/src/components/molecules";

export const BlogPostSkeleton = () => {
  return (
    <PageContainer>
      <BreadcrumbPanel
        crumbs={[
          { id: "loading1", label: "...", url: "#" },
          { id: "loading2", label: "...", url: "#" }
        ]}
        sx={{ pl: [2, 3], pr: [2, 3] }}
      />
      <PageContainer maxWidth="800px" sx={{ margin: "auto" }}>
        <Skeleton variant="text" width="80%" height={60} sx={{ mb: 2 }} />

        <Box sx={{ width: "100%", aspectRatio: "16 / 9", mb: 3 }}>
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>

        <Skeleton variant="text" width="20%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="100%" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="100%" height={32} sx={{ mb: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="90%" height={24} sx={{ mb: 3 }} />

          <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="80%" height={24} sx={{ mb: 3 }} />
        </Box>
      </PageContainer>
      <Divider />
      <Box sx={{ mt: 3, px: 2 }}>
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "center"
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <Grid
              key={i}
              size={{
                xs: 12,
                sm: 6,
                lg: 3
              }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={200}
                sx={{ mb: 1 }}
              />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="90%" />
            </Grid>
          ))}
        </Grid>
      </Box>
    </PageContainer>
  );
};
